var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stripe-checkout',{ref:"checkoutRef",attrs:{"pk":_vm.publishableKey,"items":_vm.items,"session-id":_vm.sessionId,"successUrl":_vm.successUrl,"cancelUrl":_vm.cancelUrl}},[_c('template',{slot:"checkout-button"},[_c('button',{on:{"click":_vm.checkout}},[_vm._v("Shut up and take my money!")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }